import { render, staticRenderFns } from "./quesDetail.vue?vue&type=template&id=5b67ee41&scoped=true&"
import script from "./quesDetail.vue?vue&type=script&lang=ts&"
export * from "./quesDetail.vue?vue&type=script&lang=ts&"
import style0 from "./quesDetail.vue?vue&type=style&index=0&id=5b67ee41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67ee41",
  null
  
)

export default component.exports